module.exports = __webpack_public_path__ + "static/media/judge-ivan.ad55aeb2.jpg";